const conselho_fiscal = {
  pessoas: [
    {
      nome: 'Arnaldo Alves dos Santos',
      cargo: 'Conselheiro',
      descricao: 'Itaú Unibanco',
      imagem: 'conselho1',
    },
    {
      nome: 'Fabio Fujino Rey',
      cargo: 'Conselheiro',
      descricao: 'Banco ABC Brasil',
      imagem: 'conselho2',
    },
    {
      nome: 'Luiz Guilherme Mendonça',
      cargo: 'Conselheiro',
      descricao: 'Credit Suisse Brasil',
      imagem: 'conselho3',
    },
  ],
};

export { conselho_fiscal };
